export const API_PREFIX = '/tch/hr-workbench'

// color 取 iView 2.8 Tag 支持的 red / yellow / blue / green / default
export const PROBATION_LEVEL = {
  expired: { text: '已逾期', color: 'red' },
  urgent: { text: '即将到期', color: 'yellow' },
  near: { text: '临近到期', color: 'blue' },
  normal: { text: '试用期中', color: 'default' },
  done: { text: '已归档', color: 'green' },
  missing: { text: '入职日缺失', color: 'default' }
}

export const PROBATION_RESULT = {
  CONVERTED: { text: '转正', color: 'green' },
  EXTENDED: { text: '延长试用', color: 'yellow' },
  TERMINATED: { text: '未通过', color: 'red' }
}

export const REVIEW_LEVEL = {
  overdue: { text: '已逾期', color: 'red' },
  soon: { text: '即将到节点', color: 'yellow' },
  upcoming: { text: '未到节点', color: 'default' },
  done: { text: '已回访', color: 'green' }
}

export const REVIEW_RESULT = {
  GOOD: { text: '良好稳定', color: 'green' },
  NORMAL: { text: '一般观察', color: 'blue' },
  CONCERN: { text: '有问题需支持', color: 'yellow' },
  RISK: { text: '高风险需干预', color: 'red' }
}

export const REVIEW_CHANNELS = ['微信', '电话', '视频会议', '邮件']

export const CONTRACT_LEVEL = {
  expired: { text: '已超期', color: 'red' },
  expiring: { text: '即将到期', color: 'yellow' },
  normal: { text: '有效期内', color: 'green' },
  missing: { text: '未登记合同', color: 'default' }
}

export const FOLLOWUP_TYPE = {
  ABSENT: { text: '旷课', color: 'red' },
  LOST: { text: '旷课·失联', color: 'red' },
  LEAVE: { text: '请假', color: 'yellow' },
  LATE: { text: '迟到', color: 'blue' }
}

export const FOLLOWUP_RESULT = {
  // 弹窗可选（新）
  NORMAL_CLASS: { text: '已正常上课', color: 'green' },
  CONTINUE: { text: '待继续跟进', color: 'yellow' },
  // 历史展示兼容（旧，不可再选）
  CONTACTED: { text: '已联系本人', color: 'blue' },
  CONFIRMED: { text: '已确认原因', color: 'blue' },
  MAKEUP: { text: '已安排补课', color: 'green' },
  WARNED: { text: '已警告提醒', color: 'yellow' },
  ESCALATED: { text: '已升级处理', color: 'red' },
  EXCUSED: { text: '免责（不可抗力）', color: 'green' }
}

/** 出勤跟进弹窗下拉：仅新两项 */
export const FOLLOWUP_RESULT_OPTIONS = {
  NORMAL_CLASS: FOLLOWUP_RESULT.NORMAL_CLASS,
  CONTINUE: FOLLOWUP_RESULT.CONTINUE
}

export const BIZ_TYPE = {
  PROBATION: '试用期',
  REVIEW: '新外教回访',
  CONTRACT: '合同续签',
  FOLLOWUP: '出勤跟进'
}

export const TODO_KIND = {
  PROBATION: { text: '试用期', button: '处理' },
  CONTRACT: { text: '合同', button: '续签' },
  FOLLOWUP: { text: '出勤跟进', button: '跟进' },
  REVIEW: { text: '新外教回访', button: '回访' },
  RISK: { text: '出勤风险', button: '监测' }
}

export const SEVERITY = {
  danger: { text: '紧急', color: '#E6464E' },
  warning: { text: '关注', color: '#E89F2D' },
  info: { text: '预告', color: '#2d8cf0' }
}

export function codeText (dict, code) {
  if (!code) {
    return ''
  }
  return (dict[code] && dict[code].text) || code
}

export function codeColor (dict, code) {
  return (dict[code] && dict[code].color) || 'default'
}

export function tchLabel (row) {
  if (!row) {
    return ''
  }
  return row.tchName || (row.tchId == null ? '' : String(row.tchId))
}

function pad2 (n) {
  return n < 10 ? '0' + n : '' + n
}

export function toDayString (v) {
  if (!v) {
    return ''
  }
  if (typeof v === 'string') {
    return v.length >= 10 ? v.slice(0, 10) : ''
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1) + '-' + pad2(v.getDate())
  }
  return ''
}

export const ADVISER_STORAGE_KEY = 'hrWorkbench.studyAdviserId'

export function readStoredAdviserId () {
  try {
    let v = window.localStorage.getItem(ADVISER_STORAGE_KEY)
    if (v == null || v === '' || v === 'all') {
      return 'all'
    }
    return String(v)
  } catch (e) {
    return 'all'
  }
}

export function writeStoredAdviserId (adviserId) {
  try {
    if (adviserId === 'all' || adviserId === '' || adviserId == null) {
      window.localStorage.removeItem(ADVISER_STORAGE_KEY)
    } else {
      window.localStorage.setItem(ADVISER_STORAGE_KEY, String(adviserId))
    }
  } catch (e) {}
}

/** route.query > localStorage > all */
export function resolveAdviserId (routeQuery) {
  let q = routeQuery || {}
  if (q.studyAdviserId != null && q.studyAdviserId !== '') {
    return String(q.studyAdviserId)
  }
  return readStoredAdviserId()
}

export function badgesAdviserParam () {
  return adviserParam(readStoredAdviserId())
}

export function adviserParam (adviserId) {
  if (adviserId === 'all' || adviserId === '' || adviserId == null) {
    return {}
  }
  return { studyAdviserId: Number(adviserId) }
}

function csvCell (v) {
  if (v == null) {
    return ''
  }
  let s = String(v)
  if (/[",\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"'
  }
  return s
}

export function downloadCsv (filename, headers, rows) {
  let lines = [headers].concat(rows || []).map(function (cols) {
    return (cols || []).map(csvCell).join(',')
  })
  let blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' })
  let link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}

export function daysText (daysLeft) {
  if (daysLeft == null) {
    return '—'
  }
  if (daysLeft < 0) {
    return '逾期 ' + Math.abs(daysLeft) + ' 天'
  }
  if (daysLeft === 0) {
    return '今天到期'
  }
  return '剩 ' + daysLeft + ' 天'
}



// WEBPACK FOOTER //
// ./src/components/hrWorkbench/constants.js